import React from 'react'
import { Button, Spinner } from 'react-angle-dashboard-components'

interface IFooterButtonsProps {
  onContinue: () => void
  onCancel: () => void
  onBack: () => void
  hideBackButton?: boolean
  isContinueDisabled?: boolean
  isLoading?: boolean
  continueButtonText?: string
  backButtonText?: string
}

const FooterButtons = ({
  onContinue,
  onCancel,
  onBack,
  hideBackButton = false,
  isContinueDisabled = false,
  isLoading = false,
  continueButtonText = 'Continue',
  backButtonText = 'Back'
}: IFooterButtonsProps) => {
  return (
    <div
      className="d-flex fixed-bottom w-full justify-content-between"
      style={{
        paddingLeft: '10%',
        paddingRight: '10%',
        paddingBottom: 10,
        paddingTop: 10,
        borderTop: '1.5px solid lightGray',
        background: 'white'
      }}
    >
      <Button onClick={onCancel} variant="outline-primary">
        Cancel
      </Button>
      <div className="d-flex">
        {!hideBackButton && (
          <Button onClick={onBack} variant="outline-primary">
            {backButtonText}
          </Button>
        )}
        <Button
          onClick={onContinue}
          className="ml-4 d-flex justify-content-center"
          disabled={isContinueDisabled}
        >
          {continueButtonText}
          {isLoading && <Spinner size="sm" className="ml-2" animation="border" />}
        </Button>
      </div>
    </div>
  )
}

export default FooterButtons
